import { z } from "zod";

const EMPLOYMENT_STATUS = [
  "EMPLOYED",
  "UNEMPLOYED",
  "RETIRED",
  "STUDENT",
] as const;

export const EMPLOYMENT_STATUS_OPTIONS: {
  value: (typeof EMPLOYMENT_STATUS)[number];
  label: string;
}[] = [
  { value: "EMPLOYED", label: "Employed" },
  { value: "UNEMPLOYED", label: "Unemployed" },
  { value: "RETIRED", label: "Retired" },
  { value: "STUDENT", label: "Student" },
];

const zNonEmptyString = z
  .string()
  .refine((s) => !!s?.trim(), { message: "Required" });

// Schema for the Additional Info form
export const additionalInfoSchema = z.object({
  // Name
  given_name: zNonEmptyString,
  middle_name: z.string().optional(),
  family_name: zNonEmptyString,
  // Country / address
  country_of_tax_residence: zNonEmptyString,
  street_address: zNonEmptyString,
  city: zNonEmptyString,
  state: zNonEmptyString,
  postal_code: zNonEmptyString,
  unit: z.string().optional(),
  phone_number: z
    .string({ error: "Phone number is required" })
    .min(10, "Invalid phone number")
    .regex(/^\+?[ 0-9\-()]+$/, "Invalid phone number"),
  // Employment
  employment_status: z.enum(EMPLOYMENT_STATUS),
  employer: z.string().optional(),
  employer_address: z.string().optional(),
  position: z.string().optional(),
  function: z.string().optional(),
});

export type AdditionalInfoSchema = z.infer<typeof additionalInfoSchema>;

export const additionalInfoResolver = (
  data: AdditionalInfoSchema,
  ctx: z.RefinementCtx,
) => {
  // If employment status is "Employed", then job-related fields are required
  if (data.employment_status === "EMPLOYED") {
    if (!data.employer) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Required",
        path: ["employer"],
      });
    }

    if (!data.employer_address) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Required",
        path: ["employer_address"],
      });
    }

    if (!data.position) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Required",
        path: ["position"],
      });
    }

    if (!data.function) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Required",
        path: ["function"],
      });
    }
  }
};
